import axios from "axios";

export default async function onGetImageUploadUrl() {
    return await axios.get(
        `/upload`
    );
}
